export default __webpack_public_path__ + "eab6c2f38b202a706c9c97ef5baa5885.png";